import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CmsComponent } from './cms.component';
import { GalleryComponent } from './gallery/gallery.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CmsDetailPageComponent } from './cms-detail-page/cms-detail-page.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ShopDetailComponent } from './shop-detail/shop-detail.component';
import { MatIconModule } from '@angular/material/icon';
import { ShopDetailProductBlockComponent } from './shop-detail/shop-detail-product-block/shop-detail-product-block.component';
import { ShopDetailProductMerchComponent } from './shop-detail/shop-detail-product-merch/shop-detail-product-merch.component';
import { SharedModule } from '../shared/shared.module';
import { ShopDetailBuySectionComponent } from './shop-detail/shop-detail-buy-section/shop-detail-buy-section.component';
import { FormsModule } from '@angular/forms';
import { MouldingMerchDialogComponent } from './moulding-merch-dialog/moulding-merch-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BuilderSharedModule} from '../builder/builder.module';
import { ShopComponent } from "../shared/components/shop/shop.component";
import { IsChildPageGuard } from "./is-child-page.guard";
import { ShopDetailProductBlocksComponent } from './shop-detail/shop-detail-product-blocks/shop-detail-product-blocks.component';

const routes: Routes = [
  { path: 'customer-art/:slug', component: GalleryComponent, canDeactivate: [IsChildPageGuard]},
  { path: 'customer-art/:slug/:id', component: GalleryComponent, canDeactivate: [IsChildPageGuard]},
  { path: 'blog', component: CmsComponent },
  { path: 'shop', component: ShopComponent },
  { path: 'price-list', component: ShopComponent },
  { path: 'shop/:productGroup', component: ShopDetailComponent },
  { path: ':slug', component: CmsDetailPageComponent },
  { path: ':folder/:slug', component: CmsDetailPageComponent }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    MatPaginatorModule,
    MatIconModule,
    MatTooltipModule,
    FormsModule,
    BuilderSharedModule
  ],
  declarations: [
    CmsComponent,
    GalleryComponent,
    CmsDetailPageComponent,
    ShopDetailComponent,
    ShopDetailProductBlockComponent,
    ShopDetailProductMerchComponent,
    ShopDetailBuySectionComponent,
    MouldingMerchDialogComponent,
    ShopDetailProductBlocksComponent
  ],
  providers: [IsChildPageGuard]
})
export class CmsModule {
}
